import React from 'react';
import { ButtonAddStyle } from './style';
import { handleAddProject } from '../../../functions/SincronizaNFe/handleAddProject';

export default function ButtonAddProject({
  cnpj,
  setProjectAlert,
  company,
  clientAndProject,
  rateio,
  value,
  setTotalValueCnpj1,
  setTotalValueCnpj2,
  totalValueCnpj1,
  totalValueCnpj2,
  setTotalRateio,
  totalRateio,
  setTotalValueStatus,
  setProjects,
  setCompany,
  setRateio,
  setValue,
  projects,
  setDuplicateProjectError,
  monthName,
}) {
  return (
    <ButtonAddStyle
      onClick={() =>
        handleAddProject(
          cnpj,
          setProjectAlert,
          company,
          clientAndProject,
          rateio,
          value,
          setTotalValueCnpj1,
          setTotalValueCnpj2,
          totalValueCnpj1,
          totalValueCnpj2,
          setTotalRateio,
          totalRateio,
          setTotalValueStatus,
          setProjects,
          setCompany,
          setRateio,
          setValue,
          projects,
          setDuplicateProjectError,
        )
      }
      disabled={
        projects.length >= 25 ||
        totalRateio >= 100 ||
        rateio <= 0 ||
        rateio > 100 ||
        isNaN(rateio) ||
        monthName === 'Selecione um mês' ||
        monthName === 'Nenhum mês selecionado'
          ? true
          : false
      }
    >
      Adicionar
    </ButtonAddStyle>
  );
}
